import LessonLibrary from '@src/pages/lessonlibrary/LessonLibrary';
import { useSimulateSchool } from './useSimulateSchool';

/** OP-3164: the lesson library, with keyword searches ranked by AI. OP-3227: and simulated per school. */
function AiLessonLibrary() {
  const simulate = useSimulateSchool();
  return <LessonLibrary aiSearch aiSimulate={simulate} />;
}

export default AiLessonLibrary;
